import {ActionType} from 'redux-promise-middleware';
import {CITY_LOAD_DATA} from './city-actions';
import {ROUTER_DATA_LOAD_FULFILLED} from 'router/router-actions';

export const initialState = () => ({
    isPending: false,
    data: {},
    // {
    //     phone_number,
    //     relative_url,
    //     monthly_phone_number,
    //     monthly_relative_url,
    //     timezone,
    //     weekday_hours,
    //     slug,
    //     city,
    //     phone_number_friendly,
    //     display_name,
    //     description,
    //     monthly_description,
    //     monthly_phone_number_friendly,
    //     longitude,
    //     state,
    //     weekend_hours,
    //     latitude,
    //     support_email,
    //     transient_meta_title,
    //     transient_meta_description,
    //     monthly_meta_title,
    //     monthly_meta_description
    //     search_bounds: {
    //         sw_lat: 0,
    //         sw_lng: -0,
    //         ne_lat: 0,
    //         ne_lng: -0
    //     }
    // }
    error: null,
});

export default function city(state = initialState(), {type, payload}) {
    switch (type) {
        case `${CITY_LOAD_DATA}_${ActionType.Pending}`: {
            return {
                ...state,
                isPending: true,
            };
        }

        case `${CITY_LOAD_DATA}_${ActionType.Fulfilled}`: {
            return {
                ...state,
                isPending: false,
                data: payload.data.data,
            };
        }

        case `${CITY_LOAD_DATA}_${ActionType.Rejected}`: {
            return {
                ...state,
                isPending: false,
                data: null,
                error: 'Could not load city data.',
            };
        }

        case ROUTER_DATA_LOAD_FULFILLED: {
            const {city: cleanedCityState} = payload;

            if (cleanedCityState) {
                return cleanedCityState;
            } else {
                return state;
            }
        }

        default:
            return state;
    }
}
